import { createSlice } from '@reduxjs/toolkit';

/**
 * UI slice state shape (placeholder).
 *
 * Concrete fields (drawer open/closed flag, snackbar queue) land in
 * a follow-up 4.x task per public-website design §2.4 / §3.1. This
 * file is the empty stub task 4.4 ships so `configureStore` has
 * every reducer wired up from day one.
 */
export interface UiState {
  /** Placeholder discriminator until the drawer/snackbar fields land. */
  readonly placeholder?: undefined;
}

const initialState: UiState = {};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {},
});

export default uiSlice.reducer;
